
import { QdeService } from 'src/app/services/qde.service';
import { Component, OnInit, NgZone } from '@angular/core';
import { getDeviceSize } from 'src/app/utilities/utilities.file';
import { cardAnimations } from 'src/app/utilities/animations';
import { IwService } from "../../services/iw.service";
import { Router, ActivatedRoute } from '@angular/router';
import { GENERIC_ERROR, ISTATACARD, base_https_url, DOC_UPLOAD_LINK, IS_CAMPAIGN, TRACK_APP, DIGITAL_TRACK_APP,  TRACK_GEN_SHIPMENT_RESPONSE_URL_DECRYPT, TRACK_GEN_UPDATE_INSTRUCTION_URL_DECRYPT } from 'src/app/config/app-settings.config';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { MatDialog } from "@angular/material/dialog";
import { CardUpgradePopupComponent } from '../card-upgrade-popup/card-upgrade-popup.component';
import { LoaderService } from 'src/app/services/loader.service';
import { ThemeService } from 'src/app/services/theme.service';
import { HttpClient } from '@angular/common/http';
import { TrackCardDeliveryService } from 'src/app/services/track-card-delivery.service';
import { DatePipe } from '@angular/common';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';



declare var $: any;
declare var jQuery: any;
declare var _satellite: any;
declare var AmoScript: Function;
declare var analytics: any;


@Component({
  selector: 'app-card-tracking-and-delivery',
  templateUrl: './card-tracking-and-delivery.component.html',
  styleUrls: ['./card-tracking-and-delivery.component.scss'],
  animations: [cardAnimations],
  providers: [DatePipe]
})
export class CardTrackingAndDeliveryComponent implements OnInit {
  showAlicationStatusJourney:boolean = true;
  showTrackYourCardDelivery:boolean = false;
  showUpdateDeliveryInstruction:boolean = false;
  trackYourDeliveryStatus: boolean =false;
  updateDeliveryStatus: boolean =false;
  trackStatusImg: boolean = true;
  disableTrackingDeliveryTabs:boolean = true;
  disableTrackingInstructionTabs:boolean = true;
  updateLandmarkValue: any;
  subStatusFlag: boolean = false;
  deliveryDatesOptionArray =[];
  updateInstrintions: any;
  Date: any;
  showAllFlag: boolean;
  updateDate: any;
  trackCardDeliry: any;
  trackCardCurrentDateAndTime: any;
  saveInstructionSuccessMsg: boolean = false;
  bookedActiveImg: boolean = false;
  lastElement: any;
  showPreferdateMsg: boolean = true;
  showPreferdateErrorMsg: boolean = false;
  trackingBookedFailedFlag: boolean = false;
  validateSaveInstructionButtonDisabled: boolean = true;
  showServiceErrorMsg: boolean = false;
  selectedDateRes: string;
  digitalTrackVerbiages = DIGITAL_TRACK_APP;
  digitrackingCardShortCodeFlag: boolean;
  courierPartnerId:any;
  isBokedFalied: boolean = false;
  firstStepNameHeader1:string;
  firstStepNameHeader2:string;
  firstStepNameHeaderFlag: boolean= false;
  shipmentCourierName : any;
  shipmentAWBName: any;
  shipmentPreferDate : any;
  lastElementCardDeliveryVerbiages: boolean = false;
  shipmentShortCodeAWBNumber : any;
  shipmentServiceShortCodeFlag : boolean = false;
  currentTrackingApplication : boolean = true;
  // trackShipmentLinkEnabled: boolean = false;
  
  // Existing Card component types
  classString: String;
  isMobile: boolean;
  firstCardVisible: boolean = true;
  secondCardVisible: boolean = false;
  thirdCardVisible: boolean = false;
  eapplyFormLabel: any;
  appNumber: any;
  userInfo: any;
  convertedjson: any;
  firstOffer: any;
  secondOffer: any;
  thirdOffer: any;
  cardList: any;
  dcrCardUrlMapping: any;
  button_Label: any;
  fetchingDcrUrl: any;
  displayOffer = [];
  orignalCardJson: any;
  cardSelected: any;
  upgradeBody: any;
  sbic_card: any;
  dcrSubmissionVerbiageDCR: any;
  user_message: any;
  card_type: any;
  completeApplicationBody: any;
  errorCardUpgrade: string;
  finalCardJson: any;
  disableCompleteButton: boolean = true;
  cardName: any;

  //dcrSubmissionVerbiageDCR: any;
  submit_button = '';
  disableService = 0;
  got_to_button = '';
  close_button = ''
  trackResponse: any;
  orignalCardJsonTrack: any;
  TATACARD = ISTATACARD;
  offerImage: any;
  dcrPath: any;
  base_url = base_https_url;
  fromTrack: boolean;
  mobileNumber: any;
  emailId: any;
  errorMessage: any;
  showOfferFlag: any;
  offerVerbiage: any;
  promoCode: any;
  // errorMessage: string;
  userCity: any;
  isBanca: boolean;
  enableOffer: boolean = false;
  isCampion: boolean = false;
  gem1: any;
  gem2: any;
  gemId1Val: any;
  gemId2Val: any;

  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  fromSWIFTJourney: boolean;
  trackAppDcrData:any;
  stepsarray =[];
  imgStep1: any;
  imgStep2:any;
  newstepsarray =[];
  currentstatus = "";
  currentApplicationnumber ="0000";
  currentAwbnumber ="000";
  currentCouriername ="";
  newCardDetailedStatus:any;
  cardDelivered: boolean = false;
  courierLink ="";
  cardDeclined: boolean = false;
  cardApproved: boolean =false;
  cardIntrasit: boolean =false;
  cardRto: boolean =false;
  offerObject: any;
  isSubmit:boolean;
  isStepFailed: boolean =false;
  isImageFailed: boolean =false;
  disableTrackingInstructionFailedDelivery: boolean = false;
  isTrackDelDisabled:boolean=false; 


  constructor(public dialog: MatDialog,
    private ngZone: NgZone,
    private iw: IwService,
    private router: Router,
    private route: ActivatedRoute,
    private qdeService: QdeService,
    private sharedService: SharedServiceService,
    private trackshipmentService: TrackCardDeliveryService,
    private loaderService: LoaderService,
    private themeService: ThemeService,
    private http: HttpClient,
    private encryptDecService: EncrDecrService,
    private datePipe: DatePipe) { 
      this.partnerCode = this.themeService.partnerCode;
      // this.trackCardCurrentDate = this.datePipe.transform(this.trackCardCurrentDate, 'yyyy-MM-dd');
    }

  data ={};

  stepsInfo:any;  
  ngOnInit() {
    this.disableTrackingDeliveryTabs = true;
    this.disableTrackingInstructionTabs = true;
    this.digitrackingCardShortCodeFlag = this.sharedService.digitrackingCardShortCodeFlag;
      if(this.sharedService.digitrackingCardShortCodeFlag == true){
        this.courierPartnerId =  this.sharedService.courierPartnerId;
        this.currentAwbnumber =  this.sharedService.awbnumber;
        this.currentCouriername = this.sharedService.courierPartnerName;
        this.currentTrackingApplication = false;
        this.subStatusFlag = true;
        this.trackStatusImg = false;
        this.shipmentServiceShortCodeFlag = true;
        this.disableTrackingDeliveryTabs = false;
        this.showhideCardTrackingDelivery("Track-your-card-delivery");

      }
      else{}
   // uncomment before deployment
    this.isSubmit = this.sharedService.isSubmit;
    this.stepsInfo = this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.newCardDetailedStatus ? this.sharedService.trackApplicationResponse.newCardDetailedStatus.CardDetailedStatus: [];
    this.currentApplicationnumber = this.sharedService.applicantApplicationNumber;
    this.currentCouriername = this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.newCardDetailedStatus ? this.sharedService.trackApplicationResponse.newCardDetailedStatus.courierName: 'Not Available'; 
    this.courierLink = this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.newCardDetailedStatus ? this.sharedService.trackApplicationResponse.newCardDetailedStatus.courierLink: 'Not Available';
    this.currentAwbnumber = this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.newCardDetailedStatus ? this.sharedService.trackApplicationResponse.newCardDetailedStatus.awsNumber: 'Not Available';
    this.courierPartnerId = this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.newCardDetailedStatus ? this.sharedService.trackApplicationResponse.newCardDetailedStatus.courierPartnerId: 'Not Available';
  
     // Disabled the Track Your card Delivery Tab Prdoduction Fix --Rajesh.
    if(this.currentAwbnumber == 'Not Available' ||  this.currentAwbnumber==""){
      this.disableTrackingDeliveryTabs = true;
      this.isTrackDelDisabled=true;
    }



    // this.sharedService.trackAppAuth({}).subscribe((res: any) => {
    //   this.sharedService.trackApplicationResponse = res;
    //   this.data = res;
    //   this.currentApplicationnumber = res.data.applicationNumber;
    //   this.currentCouriername = res.newCardDetailedStatus.courierName;
    //   // this.courierLink = res.newCardDetailedStatus.courierLink;
    //   this.currentAwbnumber = res.newCardDetailedStatus.awsNumber;
    //   this.stepsInfo = res.newCardDetailedStatus.cardDetailedStatus ? res.newCardDetailedStatus.cardDetailedStatus : {};
    //   console.log("===================================>", res);
    //   console.log("===================================>stepsInfo", this.stepsInfo);
    // }, (err:any) => {});

    // commwnt before deployment end
   

    this.fromSWIFTJourney = this.sharedService.fromSwiftJourney;
    console.log("ngOnInit for card-upgrade-component");
    this.gemId1Val = this.sharedService.gemid1Val;
    console.log("Value of gem id1End is", this.gemId1Val);
    this.gemId2Val = this.sharedService.gemid2Val;
    console.log("Value of gem id1End is", this.gemId2Val);
    // this.gem1 = this.sharedService.paramsgemid1 ? this.sharedService.paramsgemid1 : '';
    // this.gem2 = this.sharedService.paramsgemid2 ? this.sharedService.paramsgemid2 : '';
    // console.log(this.gem1);
    // console.log("Value of GEMOne",this.gem1);

    // this.trackAppDcrData = this.iw.getApplicationStatusData();

    console.log(this.trackAppDcrData);



    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.dcrCardUrlMapping = this.iw.geteapplyCardUpgradeMappingDCR();
    this.dcrSubmissionVerbiageDCR = this.iw.geteapplySubmissionVerbiageDCR();
    this.isBanca = this.sharedService.paramschannel && this.sharedService.paramschannel == '901' ? true : false;
    this.offerImage = this.TATACARD ? '/tata-card-en/resources/img/eapply/voucher.png' : '/sbi-card-en/resources/img/eapply/voucher.png';
    IS_CAMPAIGN ? (this.isCampion = true) : (this.isCampion = false)
    if (this.sharedService.fromSwiftJourney) {
      if (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.data.leadRefNo) {
        this.trackResponse = this.sharedService.trackApplicationResponse;
        this.mobileNumber = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber : '';
        this.emailId = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : '';
        this.trackApplication();
        this.fromTrack = true;
      } else {
        this.appNumber = this.qdeService.qdeSubmitData;
        this.userInfo = this.qdeService.aboutData;
        this.mobileNumber = this.userInfo && this.userInfo.WSCallUserMobileNumber ? this.userInfo.WSCallUserMobileNumber : '';
        this.emailId = this.userInfo && this.userInfo.WSCallUserEmailId ? this.userInfo.WSCallUserEmailId : '';
        let origanlXml = JSON.parse(localStorage.getItem("convertedJson"));
        this.orignalCardJson = origanlXml
        if (this.orignalCardJson) {
          if (this.orignalCardJson.root && this.orignalCardJson.root.card_information && this.orignalCardJson.root.card_information.card_type) {
            this.cardSelected = this.orignalCardJson.root.card_information.card_type;
          }
          if (this.orignalCardJson.root && this.orignalCardJson.root.card_information && this.orignalCardJson.root.card_information.card_name) {
            this.cardName = this.orignalCardJson.root.card_information.card_name;
            console.log(this.cardName);
            this.sharedService.cardName = this.cardName
          }
          console.log(this.cardSelected);
          this.sbic_card = this.orignalCardJson.root.card_information.card_name;
          this.sharedService.sbic_card_Type = this.orignalCardJson.root.card_information.card_type
          console.log(this.sbic_card);
          if (window['digitalData']) {
            window['digitalData'].card = { cardName: this.sbic_card };
            window["digitalData"].gemId1 = { GEMID1: this.gemId1Val };
            window["digitalData"].gemId2 = { GEMID2: this.gemId2Val };

          }
          sessionStorage.setItem('cardName', this.sbic_card);
          this.finalCardJson = this.orignalCardJson;
          this.sharedService.initialCardJson = this.finalCardJson;
        }
        if ((this.sharedService.navigateToCompleteApp ||
          this.sharedService.navigateToDocUpload ||
          this.sharedService.navigateToScheduleAppointment ||
          this.sharedService.navigateToResheduleAppointment ||
          this.sharedService.navigateToAddon ||
          this.sharedService.navigateToCrossSell) && (this.appNumber.applicationNumber)) {
          if (this.appNumber && this.appNumber.upSell && (this.appNumber.upSell == 'Y' || this.appNumber.upSell == 'E' || this.appNumber.upSell == 'X')) {
            this.enableOffer = true;
            this.submit_button = 'Proceed';
          }
        }
      }
    }
    else {
      if (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.leadRefNo) {
        this.trackResponse = this.sharedService.trackApplicationResponse;
        this.mobileNumber = this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber : '';
        this.emailId = this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId : '';
        this.trackApplication();
        this.fromTrack = true;
      } else {
        this.appNumber = this.qdeService.qdeSubmitData;
        this.userInfo = this.qdeService.aboutData;
        this.mobileNumber = this.userInfo && this.userInfo.WSCallUserMobileNumber ? this.userInfo.WSCallUserMobileNumber : '';
        this.emailId = this.userInfo && this.userInfo.WSCallUserEmailId ? this.userInfo.WSCallUserEmailId : '';
        let origanlXml = JSON.parse(localStorage.getItem("convertedJson"));
        this.orignalCardJson = origanlXml
        if (this.orignalCardJson) {
          if (this.orignalCardJson.root && this.orignalCardJson.root.card_information && this.orignalCardJson.root.card_information.card_type) {
            this.cardSelected = this.orignalCardJson.root.card_information.card_type;
          }
          if (this.orignalCardJson.root && this.orignalCardJson.root.card_information && this.orignalCardJson.root.card_information.card_name) {
            this.cardName = this.orignalCardJson.root.card_information.card_name;
            console.log(this.cardName);
            this.sharedService.cardName = this.cardName
          }
          console.log(this.cardSelected);
          this.sbic_card = this.orignalCardJson.root.card_information.card_name;
          this.sharedService.sbic_card_Type = this.orignalCardJson.root.card_information.card_type
          console.log(this.sbic_card);
          if (window['digitalData']) {
            window['digitalData'].card = { cardName: this.sbic_card };
            window["digitalData"].gemId1 = { GEMID1: this.gemId1Val };
            window["digitalData"].gemId2 = { GEMID2: this.gemId2Val };

          }
          sessionStorage.setItem('cardName', this.sbic_card);
          this.finalCardJson = this.orignalCardJson;
          this.sharedService.initialCardJson = this.finalCardJson;
        }
        if ((this.sharedService.navigateToCompleteApp ||
          this.sharedService.navigateToDocUpload ||
          this.sharedService.navigateToScheduleAppointment ||
          this.sharedService.navigateToResheduleAppointment ||
          this.sharedService.navigateToAddon ||
          this.sharedService.navigateToCrossSell) && (this.appNumber.applicationNumber)) {
          if (this.appNumber && this.appNumber.upSell && (this.appNumber.upSell == 'Y' || this.appNumber.upSell == 'E' || this.appNumber.upSell == 'X')) {
            this.enableOffer = true;
            this.submit_button = 'Proceed';
          }
        }
      }
    }

    this.displayVerbiage();
    this.showOffer();

    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    }
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    };
    this.fetchOffer();

    window.onunload = (e) => {
      e.preventDefault();
      this.ngZone.run(() => {
        this.CardUpgradeDialog()
      });
    };


    if (this.sharedService.fromSwiftJourney) {
      if (window['analytics']) {
        console.log('Application Number is', this.sharedService.trackApplicationResponse.data.applicationNumber);
        console.log('Lead Reference Number is', this.sharedService.trackApplicationResponse.data.leadRefNo);
        analytics.track('eapply__page__decision_application_submittion', {
          'PAGE_NAME': window["digitalData"].page.pageName,
          'PAGE_URL': window["digitalData"].page.PAGE_URL,
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'CARD_TYPE': this.sharedService.sbic_card_Type,
          'APP_NUMBER': this.sharedService.trackApplicationResponse.data.applicationNumber,
          'LEAD_REF_NUMBER': this.sharedService.trackApplicationResponse.data.leadRefNo,
          'status': this.sharedService.trackApplicationResponse.data.statusCode,
          'First_Name': this.sharedService.trackApplicationResponse.data.applicantDetails.firstName,
          'Last_Name': this.sharedService.trackApplicationResponse.data.applicantDetails.lastName,
          'Mobile_No': this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber,
          'Email': this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId,
          'Pan': this.sharedService.trackApplicationResponse.data.applicantDetails.pan,
          'DOB': this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth
        });
      }
    }
    else{
      /* Analytics added */
      if(window['analytics']){
        console.log('Application Number is', this.appNumber.applicationNumber);
        console.log('Lead Reference Number is', this.appNumber.leadRefNo);
        analytics.track('eapply__page__decision_application_submittion', {
        'PAGE_NAME': window["digitalData"].page.pageName,
        'PAGE_URL': window["digitalData"].page.PAGE_URL,
        'MODE_OF_CONVERSION': '',
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
        'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
        'CHANNEL_NAME': this.sharedService.paramschannel,
        'JOURNEY_NAME': 'EAPPLY',
        'CARD_TYPE': this.sharedService.sbic_card_Type,
        'APP_NUMBER': this.appNumber.applicationNumber,
        'LEAD_REF_NUMBER':this.appNumber.leadRefNo,
        'status': this.appNumber.statusCode,
        'First_Name' : this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserFirstName ? this.sharedService.qdeSubmitData.WSCallUserFirstName :this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName,
        'Last_Name' : this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserLastName? this.sharedService.qdeSubmitData.WSCallUserLastName :this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName,
        'Mobile_No' :this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserMobileNumber? this.sharedService.qdeSubmitData.WSCallUserMobileNumber: this. sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber,
        'Email' :this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserEmailId? this.sharedService.qdeSubmitData.WSCallUserEmailId: this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId,
        'Pan':this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserPanNumber? this.sharedService.qdeSubmitData.WSCallUserPanNumber : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan,
        'DOB' : this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserDOB? this.sharedService.qdeSubmitData.WSCallUserDOB : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth
        });
      }
    }
    

    this.stepsarray = [];   
    let res: any;
    res = this.iw.getApplicationStatusData();
      console.log("getapplicationtr", res);
      // if(res && res.applicationStatusData && res.applicationStatusData.stepsInfo) {
      if(res && res.applicationStatusData && res.applicationStatusData.stepsInfo) {
        this.stepsarray = res.applicationStatusData.stepsInfo;
        // this.stepsarray = res.applicationStatusData.offerInfo;
      }
      if(res && res.applicationStatusData && res.applicationStatusData.offerInfo) {
        this.offerObject = res.applicationStatusData.offerInfo;
      } 
       console.log("getapplicationtr==========", this.stepsarray);
       console.log("newstepsarry", this.newstepsarray);

      this.firstStepValueStatus();
    
  }


  // ngAfterViewChecked() {
  //   if(this.stepsInfo[3].stepState == 'Not Applicable'){
  //     if(this.stepsInfo[2].stepState == 'Completed' && !(this.cardApproved)){
  //       this.classString = 'completed3';
  //     }else if(this.stepsInfo[1].stepState == 'Completed'){
  //       this.classString = 'completed2';
  //     }else if(this.stepsInfo[0].stepState == 'Completed'){
  //       this.classString = 'completed1';
  //     }
  //   }else{
  //     if(this.stepsInfo[3].stepState == 'Completed' && !(this.cardApproved)){
  //       this.classString = 'complete4';
  //     }else if(this.stepsInfo[2].stepState == 'Completed' && !(this.cardApproved)){
  //       this.classString = 'complete3';
  //     }else if(this.stepsInfo[1].stepState == 'Completed'){
  //       this.classString = 'complete2';
  //     }else if(this.stepsInfo[0].stepState == 'Completed'){
  //       this.classString = 'complete1';
  //     }
  //   }
    
  // }
  // getDrcFromURL() {
  //   this.route.queryParams.subscribe(query => {
  //     if (query) {
  //       let saveId = query.saveId;
  //       const urlPath = query.path;
  //       const referalCode = query.referralcode;
  //       // const theme = query.theme;
  //       // this.setThemeByParam(theme);
  //       this.sharedService.paramsappNumber = query.appNo;
  //       this.sharedService.paramsmobileNo = query.mobileNo;
  //       this.sharedService.paramsfirstName = query.fname;
  //       this.sharedService.paramsgemid1 = query.GEMID1;
  //       this.sharedService.paramsgemid2 = query.GEMID2;
  //       let gem11= this.sharedService.paramsgemid1;
  //       console.log("Value of GEMMMMEnd",gem11);
  //     }
  //   });
  // }


  CardUpgradeDialog(): void {
    const dialogRef = this.dialog.open(CardUpgradePopupComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed");
    });
  }


  trackApplication() {
    console.log("trackApplication called from card upgrade component")
    if(this.sharedService.fromSwiftJourney){
      let card_type = this.sharedService.trackApplicationResponse.data.cardType;
      this.cardSelected = this.sharedService.trackApplicationResponse.data.cardType;
      if (card_type === "FABP" || card_type === "TSTV") {
        card_type = "VISC";
        this.cardSelected = card_type;
      }
      console.log(card_type);
      let url;
      let urlNotFound: boolean = true;
      console.log("DCR url mapping", this.dcrCardUrlMapping);
      this.dcrCardUrlMapping.forEach(element => {
        console.log("card type", element.key_name);
        if (element.key_name === card_type) {
          url = element.key_value;
          urlNotFound = true;
          console.log("card type inside if", element.key_name);
        }
      });
      if (!urlNotFound) {
        console.log("entering urlNotFound error");
        this.sharedService.abortMessage = TRACK_APP.trackError;
        return this.router.navigate(['', 'error']);
      }
      this.iw.getDcrXmlResponse(url, this.sharedService.paramschannel).subscribe((xml: any) => {
        console.log("entered getDCRXMLresponse from card upgrade component");
        if (xml) {                                       //================> this get call is not happening as there is no coonsole.log for this get. need to look
          console.log("getDcrXmlResponse from track application in card upgrade component", xml);
          let convertedjson = xml;
          if (convertedjson) {
            this.orignalCardJson = convertedjson;
            ISTATACARD ? this.orignalCardJson = this.orignalCardJson.root : this.orignalCardJson
            this.cardSelected = this.orignalCardJson.root.card_information.card_type;
            this.cardName = this.orignalCardJson.root.card_information.card_name;
            this.sharedService.cardName = this.cardName
  
            console.log(this.cardSelected);
            this.sbic_card = this.orignalCardJson.root.card_information.card_name;
            console.log(this.sbic_card);
            if (window['digitalData']) {
              window['digitalData'].card = { cardName: this.sbic_card }
            }
            sessionStorage.setItem('cardName', this.sbic_card);
            this.finalCardJson = this.orignalCardJson;
            this.sharedService.initialCardJson = this.finalCardJson;
            this.sharedService.sbic_card_Type = this.orignalCardJson.root.card_information.card_type;
            this.displayVerbiage();
          }
        }
      }, error => {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      });
    }
    else{
      let card_type = this.sharedService.trackApplicationResponse.cardType;
      this.cardSelected = this.sharedService.trackApplicationResponse.cardType;
      if (card_type === "FABP" || card_type === "TSTV") {
        card_type = "VISC";
        this.cardSelected = card_type;
      }
      console.log(card_type);
      let url;
      let urlNotFound: boolean = true;
      console.log("DCR url mapping", this.dcrCardUrlMapping);
      this.dcrCardUrlMapping.forEach(element => {
        console.log("card type", element.key_name);
        if (element.key_name === card_type) {
          url = element.key_value;
          urlNotFound = true;
          console.log("card type inside if", element.key_name);
        }
      });
      if (!urlNotFound) {
        console.log("entering urlNotFound error");
        this.sharedService.abortMessage = TRACK_APP.trackError;
        return this.router.navigate(['', 'error']);
      }
      this.iw.getDcrXmlResponse(url, this.sharedService.paramschannel).subscribe((xml: any) => {
        console.log("entered getDCRXMLresponse from card upgrade component");
        if (xml) {                                       //================> this get call is not happening as there is no coonsole.log for this get. need to look
          console.log("getDcrXmlResponse from track application in card upgrade component", xml);
          let convertedjson = xml;
          if (convertedjson) {
            this.orignalCardJson = convertedjson;
            ISTATACARD ? this.orignalCardJson = this.orignalCardJson.root : this.orignalCardJson
            this.cardSelected = this.orignalCardJson.root.card_information.card_type;
            this.cardName = this.orignalCardJson.root.card_information.card_name;
            this.sharedService.cardName = this.cardName
  
            console.log(this.cardSelected);
            this.sbic_card = this.orignalCardJson.root.card_information.card_name;
            console.log(this.sbic_card);
            if (window['digitalData']) {
              window['digitalData'].card = { cardName: this.sbic_card }
            }
            sessionStorage.setItem('cardName', this.sbic_card);
            this.finalCardJson = this.orignalCardJson;
            this.sharedService.initialCardJson = this.finalCardJson;
            this.sharedService.sbic_card_Type = this.orignalCardJson.root.card_information.card_type;
            this.displayVerbiage();
          }
        }
      }, error => {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      });
    }
    
    
    if(this.sharedService.fromSwiftJourney){
      if (this.sharedService.trackApplicationResponse.data.promoCode.toLowerCase() == "dumy") {
        if (this.sharedService.fromSwiftJourney) {
          console.log("app number set from trackapplication if DUMY for card upgrade component");
          this.appNumber = {
            leadRefNo: this.sharedService.trackApplicationResponse.data.leadRefNo ? this.sharedService.trackApplicationResponse.data.leadRefNo : '',
            applicationNumber: this.sharedService.trackApplicationResponse.data.applicationNumber ? this.sharedService.trackApplicationResponse.data.applicationNumber : '',
            bestCardTypes: this.sharedService.trackApplicationResponse.data.WSCallBestCardTypes ? this.sharedService.trackApplicationResponse.data.WSCallBestCardTypes : [],
            // bestCardTypes: [],
            ckycStatus: (this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.ckycStatus) ? this.sharedService.trackApplicationResponse.data.applicantDetails.ckycStatus : "",
            statusCode: this.sharedService.trackApplicationResponse.data.statusCode ? this.sharedService.trackApplicationResponse.data.statusCode : '',
            statusDesc: this.sharedService.trackApplicationResponse.data.statusDescription ? this.sharedService.trackApplicationResponse.data.statusDescription : '',
            upSell: this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag ? this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag : '',
            // upSell: ''
          }
          if ((this.sharedService.trackApplicationResponse.data.applicationNumber) &&
            (this.sharedService.trackApplicationResponse.data.enableDataCaptureFlag || this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableDocumentListFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag ||
              this.sharedService.trackApplicationResponse.data.enableAddOnListFlag || this.sharedService.trackApplicationResponse.data.enableCrossSellFlag) && (this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag && (this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag == 'E' || this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag == 'Y' || this.sharedService.trackApplicationResponse.data.WSCallUpsellFlag == 'X'))) {
            this.submit_button = 'Proceed';
            this.enableOffer = true;
          }
          this.cardSelected = this.sharedService.trackApplicationResponse.data.cardType;
        }
      } else if ((this.sharedService.trackApplicationResponse.data.applicationNumber) && (this.sharedService.trackApplicationResponse.data.enableDataCaptureFlag || this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableDocumentListFlag ||
        this.sharedService.trackApplicationResponse.data.enableAddOnListFlag || this.sharedService.trackApplicationResponse.data.enableCrossSellFlag)
      ) {
        this.got_to_button = 'Go to Application'
        this.enableOffer = true;
      }
    }
    else{
      if (this.sharedService.trackApplicationResponse.promoCode.toLowerCase() == "dumy") {
        this.appNumber = {
          leadRefNo: this.sharedService.trackApplicationResponse.leadRefNo ? this.sharedService.trackApplicationResponse.leadRefNo : '',
          applicationNumber: this.sharedService.trackApplicationResponse.applicationNumber ? this.sharedService.trackApplicationResponse.applicationNumber : '',
          bestCardTypes: this.sharedService.trackApplicationResponse.WSCallBestCardTypes ? this.sharedService.trackApplicationResponse.WSCallBestCardTypes : [],
          ckycStatus: (this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.ckycStatus) ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.ckycStatus : "",
          statusCode: this.sharedService.trackApplicationResponse.statusCode ? this.sharedService.trackApplicationResponse.statusCode : '',
          statusDesc: this.sharedService.trackApplicationResponse.statusDescription ? this.sharedService.trackApplicationResponse.statusDescription : '',
          upSell: this.sharedService.trackApplicationResponse.WSCallUpsellFlag ? this.sharedService.trackApplicationResponse.WSCallUpsellFlag : ''
        }
        if ((this.sharedService.trackApplicationResponse.applicationNumber) &&
          (this.sharedService.trackApplicationResponse.enableDataCaptureFlag || this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableDocumentListFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag ||
            this.sharedService.trackApplicationResponse.enableAddOnListFlag || this.sharedService.trackApplicationResponse.enableCrossSellFlag) && (this.sharedService.trackApplicationResponse.WSCallUpsellFlag && (this.sharedService.trackApplicationResponse.WSCallUpsellFlag == 'E' || this.sharedService.trackApplicationResponse.WSCallUpsellFlag == 'Y' || this.sharedService.trackApplicationResponse.WSCallUpsellFlag == 'X'))) {
          this.submit_button = 'Proceed';
          this.enableOffer = true;
        }
        this.cardSelected = this.sharedService.trackApplicationResponse.cardType;
      } else if ((this.sharedService.trackApplicationResponse.applicationNumber) && (this.sharedService.trackApplicationResponse.enableDataCaptureFlag || this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag || this.sharedService.trackApplicationResponse.enableDocumentListFlag ||
        this.sharedService.trackApplicationResponse.enableAddOnListFlag || this.sharedService.trackApplicationResponse.enableCrossSellFlag)
      ) {
        this.got_to_button = 'Go to Application'
        this.enableOffer = true;
      }
    }

  }
  showOffer() {
    if (this.appNumber && this.appNumber.upSell && (this.appNumber.upSell == 'Y')) {
      if (this.appNumber.upSell == 'Y' && this.appNumber.bestCardTypes) {
        let lowerIndex = (this.appNumber.bestCardTypes.indexOf(this.cardSelected) - 3) >= 0 ? (this.appNumber.bestCardTypes.indexOf(this.cardSelected) - 3) : 0;
        this.cardList = this.appNumber.bestCardTypes.slice((lowerIndex), this.appNumber.bestCardTypes.indexOf(this.cardSelected));
        let dcrCardUrlMappingCard: any = []
        let checkUrls: boolean = false;
        this.dcrCardUrlMapping.forEach(element => {
          dcrCardUrlMappingCard.push(element.key_name)
        });
        this.cardList[0] && dcrCardUrlMappingCard.includes(this.cardList[0]) ? this.createJsonFromXml(this.dcrCardUrlMapping.find(item => (item.key_name == this.cardList[0])).key_value) : null;

        this.secondOffer = this.cardList[1] && dcrCardUrlMappingCard.includes(this.cardList[1]) ? this.createJsonFromXml(this.dcrCardUrlMapping.find(item => (item.key_name == this.cardList[1])).key_value) : null;
        this.thirdOffer = this.cardList[2] && dcrCardUrlMappingCard.includes(this.cardList[2]) ? this.createJsonFromXml(this.dcrCardUrlMapping.find(item => (item.key_name == this.cardList[2])).key_value) : null;
        this.firstOffer = this.displayOffer[0];
      }
    }
  }

  showFirstCard() {
    this.firstCardVisible = true;
    this.secondCardVisible = false;
    this.thirdCardVisible = false;
  }

  showSecondCard() {
    this.firstCardVisible = false;
    this.secondCardVisible = true;
    this.thirdCardVisible = false;
  }

  showThirdCard() {
    this.firstCardVisible = false;
    this.secondCardVisible = false;
    this.thirdCardVisible = true;

  }

  cardProceed() {
    if (window['_satellite']) {
      _satellite.track("application_proceed");
    }
    if (this.themeService.themeParam) {
      sessionStorage.setItem('partner-code', this.themeService.themeParam);
      console.log("themeParam In", this.themeService.themeParam);
    }
    console.log("themeParam Out", this.themeService.themeParam);
    if (this.appNumber && this.appNumber.upSell == 'Y' && this.appNumber.bestCardTypes && this.displayOffer.length) {
      this.CardUpgradeDialog();
    }
    else {
      console.log("else 559");
      this.onComplete();
    }

    // /* Analytics added */
    if (this.sharedService.fromSwiftJourney) {
      if (window['analytics']) {
        analytics.track('eapply__click__proceed__on_application_submittion_page', {
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'CARD_TYPE': this.sharedService.sbic_card_Type,
          'First_Name': this.sharedService.trackApplicationResponse.data.applicantDetails.firstName,
          'Last_Name': this.sharedService.trackApplicationResponse.data.applicantDetails.lastName,
          'Mobile_No': this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber,
          'Email': this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId,
          'Pan': this.sharedService.trackApplicationResponse.data.applicantDetails.pan,
          'DOB': this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth
        })
      }
    }
    else {
      if (window['analytics']) {
        analytics.track('eapply__click__proceed__on_application_submittion_page', {
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'CARD_TYPE': this.sharedService.sbic_card_Type,
          'First_Name': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserFirstName ? this.sharedService.qdeSubmitData.WSCallUserFirstName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName,
          'Last_Name': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserLastName ? this.sharedService.qdeSubmitData.WSCallUserLastName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName,
          'Mobile_No': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserMobileNumber ? this.sharedService.qdeSubmitData.WSCallUserMobileNumber : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber,
          'Email': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserEmailId ? this.sharedService.qdeSubmitData.WSCallUserEmailId : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId,
          'Pan': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserPanNumber ? this.sharedService.qdeSubmitData.WSCallUserPanNumber : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan,
          'DOB': this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserDOB ? this.sharedService.qdeSubmitData.WSCallUserDOB : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth
        })
      }
    }

  }

    // Oncomplete removed card upsell call
    onComplete() {
      console.log("oncomplete", this.sharedService.navigateToCompleteApp);
      
      let gemIdVal = this.sharedService.paramsgemid1;
      console.log("Value of gem id1End is", gemIdVal);
      this.fetchOffer()
      this.sharedService.sbic_card_Type = this.finalCardJson && this.finalCardJson.root && this.finalCardJson.root.card_information && this.finalCardJson.root.card_information.card_type ? this.finalCardJson.root.card_information.card_type : '';
      if (this.sharedService.navigateToCompleteApp) {
        this.router.navigate(['/', 'complete-application']);
      } else if (this.sharedService.navigateToDocUpload) {
        let channel: any;
        let data = window['digitalData'];
        if (this.sharedService.trackApplicationResponse) {
          if(this.sharedService.fromSwiftJourney){
            channel = this.sharedService.trackApplicationResponse.data.channelCode;
          }
          else {
            channel = this.sharedService.trackApplicationResponse.channelCode;
          }
          
        } else {
          channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
        }
  
        if (channel === 'EALB' || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
          data.page = { pageName: 'sbi-card:banca doc-upload:campaign', pageType: 'Banca' };
        } else if (IS_CAMPAIGN || sessionStorage.getItem('campaign') == 'true') {
          data.page = { pageName: 'sbi-card:eapply doc-upload:campaign', pageType: 'Campaign' };
        } else if (this.sharedService.paramsshortCode || sessionStorage.getItem('sc')) {
          data.page = { pageName: 'sbi-card:reapply doc-upload:reapply', pageType: 'reapply' };
        } else {
          data.page = { pageName: 'sbi-card:eapply doc-upload:eapplyform', pageType: 'Eapply' };
        }
        sessionStorage.setItem('digitalData', JSON.stringify(data));
        if (window['_satellite']) {
          _satellite.track("doc_upload");
        }
        let appNumber: any;
        this.sharedService.appCompleted = true;
        if (this.sharedService.trackApplicationResponse) {
          if(this.sharedService.fromSwiftJourney){
            sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
            appNumber = this.sharedService.trackApplicationResponse.data.applicationNumber
            sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.data.applicationNumber);
          }
          else {
            sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
            appNumber = this.sharedService.trackApplicationResponse.applicationNumber
            sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.applicationNumber);
          }
  
        } else {
          sessionStorage.setItem('offAdd', JSON.stringify(this.sharedService.cAprofessisonalData));
          sessionStorage.setItem('currentAdd', JSON.stringify(this.sharedService.qdeSubmitData));
          sessionStorage.setItem('perAdd', JSON.stringify(this.sharedService.cApersonalData));
          sessionStorage.setItem('qdeResponseFlags', JSON.stringify(this.sharedService.flagsFromQdeResponse));
          sessionStorage.setItem('appNo', this.sharedService.qdeSuccessResponse.applicationNumber);
          sessionStorage.setItem('applicantName', this.sharedService.applicantName);
          sessionStorage.setItem('officeCity', this.sharedService.officeCity);
          sessionStorage.setItem('officeState', this.sharedService.officeState);
          sessionStorage.setItem('resiState', this.sharedService.resiState);
          appNumber = this.sharedService.qdeSuccessResponse.applicationNumber;
        }
        let requestApp = {
          "applicationNumber": appNumber
        }
        this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
          console.log("fetch params from card-upgrade component 674");
          if (window['_satellite']) {
            _satellite.track("doc_upload");
          }
          const res = { ...response.body }
          console.log("response539" + res);
          if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
            let accessToken: any;
            let expiryTime: any;
            if (response.headers && response.headers.get("access_token")) {
              accessToken = response.headers.get("access_token");
            }
            if (response.headers && response.headers.get("expiry_time")) {
              expiryTime = response.headers.get("expiry_time");
            }
  
            if (accessToken) {
              sessionStorage.setItem("s24_access_token", accessToken);
            }
            if (expiryTime) {
              sessionStorage.setItem("s24_expiry_time", expiryTime);
            }
            sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
            sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
            const docUploadStatus = res.FetchDocUploadParamsRsType.docUploadStatusFlag;
            console.log("docuploadstatus"+ docUploadStatus);
            console.log("navigate"+ this.sharedService.navigateToDocUpload);
            if (docUploadStatus == 'Y' || docUploadStatus == 'N' || docUploadStatus == 'D') {
              console.log("in if block" + docUploadStatus);
              this.sharedService.navigateToDocUpload = false;
  
              if(this.sharedService.fromSwiftJourney){
                console.log("inswifyjourney");
                console.log("navigate"+ this.sharedService.navigateToDocUpload);
                console.log("702" + this.sharedService.trackApplicationResponse);
                console.log("703" + this.sharedService.trackApplicationResponse.data.enableAppointmentFlag);
                console.log("704" + this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag);
                if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag)) {
                  console.log("inside if" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'schedule-appointment']);
                  // this.dialog.closeAll();
                } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.data.enableCrossSellFlag))) {
                  console.log("inside else if" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else {
                  console.log("inside else" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                }
              }
              else {
                console.log("In eapply journey");
                if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag)) {
                  this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.enableCrossSellFlag))) {
                  this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else {
                  this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                }
              }
              
            } else if (docUploadStatus == 'I' || docUploadStatus == '') {
              console.log("else if part" + docUploadStatus);
              this.sharedService.navigateToDocUpload = true;
              this.createHiddenForm();
            }
            console.log("before createhidden method");
            // this.createHiddenForm();
          } else {
            console.log("else part" + res.FetchDocUploadParamsRsType.docUploadStatusFlag);
            this.disableService = 0;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
            return this.createHiddenForm();
          }
        }, err => {
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
          this.createHiddenForm();
        })
  
      } else if (this.sharedService.navigateToScheduleAppointment || this.sharedService.navigateToResheduleAppointment) {
        console.log("761");
        this.router.navigate(['/', 'schedule-appointment']);
      } else if ((this.sharedService.navigateToAddon) || (this.sharedService.navigateToCrossSell)) {
        console.log("764");
        this.router.navigate(['/', 'addon-card']);
      } else {
        console.log("767");
        this.router.navigate(['/', 'success']);
      }
    }

    async createJsonFromXml(queryUrl: any) {
      await this.iw.getDcrXmlResponseForPromise(queryUrl, this.sharedService.paramschannel)
        .then(
          (xml: any) => {
            if (xml) {
              this.convertedjson = xml;
              ISTATACARD ? this.convertedjson = this.convertedjson.root : this.convertedjson
              if (this.convertedjson) {
                this.displayOffer.push(this.convertedjson)
                this.sharedService.offerlist.push(this.convertedjson)
              }
              return this.convertedjson;
            }
          }
        );
    }
  
    displayVerbiage() {
      console.log("entered display verbiages in card upgrade");
      if ((this.appNumber && this.appNumber.statusCode)) {
        this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
          console.log("printing verbiage dcr from appNumber condition", verbiage);
          if (verbiage.status_code == this.appNumber.statusCode) {
            this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
          }
  
        });
        if (!this.user_message) {
          this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
            if (verbiage.status_code == 'UNDEFINED_STATUS_CODE' || verbiage.status_code == 'UNDEFINED_STATUS_CODE_TRACK') {
              this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
            }
          });
        }
        if (this.user_message) {
          if (this.user_message.includes("{card_type}")) {
            this.user_message = this.user_message.replace(/{card_type}/g, this.cardName);
          }
          if (this.user_message.includes("{application_number}")) {
            this.user_message = this.user_message.replace(/{application_number}/g, this.appNumber.applicationNumber);
          }
          if (this.user_message.includes("{lead_ref_number}")) {
            this.user_message = this.user_message.replace(/{lead_ref_number}/g, this.appNumber.leadRefNo);
          }
          if (this.user_message.includes("{credit_limit}")) {
            this.user_message = this.user_message.replace(/{credit_limit}/g, "");
          }
          if (this.user_message.includes("{first_name}")) {
            this.user_message = this.user_message.replace(/{first_name}/g, this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName);
          }
        }
  
      } else {
        //add sharedService.trackApplicationResponse for card type app no lead ref credit limit
        if(this.sharedService.fromSwiftJourney){
          if (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.data.statusCode) {
            this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
              console.log("printing verbiage dcr from track-application condition", verbiage);
              if (verbiage.status_code == this.sharedService.trackApplicationResponse.data.statusCode) {
                this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
              }
            });
            if (!this.user_message) {
              this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
                if (verbiage.status_code == 'UNDEFINED_STATUS_CODE' || verbiage.status_code == 'UNDEFINED_STATUS_CODE_TRACK') {
                  this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
                }
              });
            }
            if (this.user_message) {
              if (this.user_message.includes("{card_type}")) {
                this.user_message = this.user_message.replace(/{card_type}/g, this.cardName);
              }
              if (this.user_message.includes("{application_number}")) {
                this.user_message = this.user_message.replace(/{application_number}/g, this.sharedService.trackApplicationResponse.data.applicationNumber);
              }
              if (this.user_message.includes("{lead_ref_number}")) {
                this.user_message = this.user_message.replace(/{lead_ref_number}/g, this.sharedService.trackApplicationResponse.data.leadRefNo);
              }
              if (this.user_message.includes("{first_name}")) {
                this.user_message = this.user_message.replace(/{first_name}/g, this.sharedService.trackApplicationResponse.data.applicantDetails.firstName);
              }
            }
          }
  
        }
        else{
          if (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.statusCode) {
            this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
              if (verbiage.status_code == this.sharedService.trackApplicationResponse.statusCode) {
                this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
              }
            });
            if (!this.user_message) {
              this.dcrSubmissionVerbiageDCR.forEach(verbiage => {
                if (verbiage.status_code == 'UNDEFINED_STATUS_CODE_TRACK') {
                  this.user_message = this.fromTrack ? verbiage.track_verbiage : verbiage.submission_verbiage;
                }
              });
            }
            if (this.user_message) {
              if (this.user_message.includes("{card_type}")) {
                this.user_message = this.user_message.replace(/{card_type}/g, this.cardName);
              }
              if (this.user_message.includes("{application_number}")) {
                this.user_message = this.user_message.replace(/{application_number}/g, this.sharedService.trackApplicationResponse.applicationNumber);
              }
              if (this.user_message.includes("{first_name}")) {
                this.user_message = this.user_message.replace(/{first_name}/g, this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName);
              }
            }
          }
        }
  
      }
    }

    goToPage() {
      console.log("gotopage");
      if(this.sharedService.fromSwiftJourney){
        console.log("from swift journey" + this.sharedService.trackApplicationResponse.data.enableDataCaptureFlag);
        console.log(this.sharedService.trackApplicationResponse.data.enableDocumentListFlag);
        if (this.sharedService.trackApplicationResponse.data.enableDataCaptureFlag) {
          console.log("inside if");
          this.router.navigate(['/', 'complete-application']);
        } else if (this.sharedService.trackApplicationResponse.data.enableDocumentListFlag) {
          console.log("inside else if");
          let channel: any;
          let data = window['digitalData'];
          if (this.sharedService.trackApplicationResponse) {
            console.log("848");
            if(this.sharedService.fromSwiftJourney){
              console.log("850");
              channel = this.sharedService.trackApplicationResponse.data.channelCode;
            }
            else {
              channel = this.sharedService.trackApplicationResponse.channelCode;
            }
          } else {
            channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
          }
    
          if (channel === 'EALB' || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
            data.page = { pageName: 'sbi-card:banca doc-upload:campaign', pageType: 'Banca' };
          } else if (IS_CAMPAIGN || sessionStorage.getItem('campaign') == 'true') {
            data.page = { pageName: 'sbi-card:eapply doc-upload:campaign', pageType: 'Campaign' };
          } else if (this.sharedService.paramsshortCode || sessionStorage.getItem('sc')) {
            data.page = { pageName: 'sbi-card:reapply doc-upload:reapply', pageType: 'reapply' };
          } else {
            data.page = { pageName: 'sbi-card:eapply doc-upload:eapplyform', pageType: 'Eapply' };
          }
          sessionStorage.setItem('digitalData', JSON.stringify(data));
          this.sharedService.appCompleted = true;
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
          sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.data.applicationNumber);
          let requestApp = {
            "applicationNumber": this.sharedService.trackApplicationResponse.data.applicationNumber
          }
          this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
            console.log("fetch params from app component 934");
            const res = { ...response.body };
            console.log("response878" + res);
            if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
              if (res.FetchDocUploadParamsRsType.status) {
                let accessToken: any;
                let expiryTime: any;
                if (response.headers && response.headers.get("access_token")) {
                  accessToken = response.headers.get("access_token");
                }
                if (response.headers && response.headers.get("expiry_time")) {
                  expiryTime = response.headers.get("expiry_time");
                }
                if (accessToken) {
                  sessionStorage.setItem("s24_access_token", accessToken);
                }
                if (expiryTime) {
                  sessionStorage.setItem("s24_expiry_time", expiryTime);
                }
                sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
                sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
                const docUploadStatus = res.FetchDocUploadParamsRsType.docUploadStatusFlag;
                console.log("docuploadstatus"+ docUploadStatus);
                console.log("navigate"+ this.sharedService.navigateToDocUpload);
                if (docUploadStatus == 'Y' || docUploadStatus == 'N' || docUploadStatus == 'D') {
                  console.log("in if block" + docUploadStatus);
                  this.sharedService.navigateToDocUpload = false;
      
                  if(this.sharedService.fromSwiftJourney){
                    console.log("inswifyjourney");
                    console.log("navigate"+ this.sharedService.navigateToDocUpload);
                    console.log("702" + this.sharedService.trackApplicationResponse);
                    console.log("703" + this.sharedService.trackApplicationResponse.data.enableAppointmentFlag);
                    console.log("704" + this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag);
                    if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag)) {
                      console.log("inside if" + this.sharedService.trackApplicationResponse);
                      this.router.navigate(['/', 'schedule-appointment']);
                      // this.dialog.closeAll();
                    } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.data.enableCrossSellFlag))) {
                      console.log("inside else if" + this.sharedService.trackApplicationResponse);
                      this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                      this.dialog.closeAll();
                    } else {
                      console.log("inside else" + this.sharedService.trackApplicationResponse);
                      this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                      this.dialog.closeAll();
                    }
                  }
                  else {
                    console.log("In eapply journey");
                    if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag)) {
                      this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                      this.dialog.closeAll();
                    } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.enableCrossSellFlag))) {
                      this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                      this.dialog.closeAll();
                    } else {
                      this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                      this.dialog.closeAll();
                    }
                  }
                  
                } else if (docUploadStatus == 'I' || docUploadStatus == '') {
                  console.log("else if part" + docUploadStatus);
                  this.sharedService.navigateToDocUpload = true;
                  this.createHiddenForm();
                }
                // this.createHiddenForm();
              }
            } else {
              window["digitalData"].error = { message: GENERIC_ERROR };
              if (window['_satellite']) {
                _satellite.track('form_error');
              }
              this.createHiddenForm();
            }
          }, err => {
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
            this.createHiddenForm();
          })
    
        } else if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag)) {
          this.router.navigate(['/', 'schedule-appointment']);
        } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.data.enableCrossSellFlag))) {
          this.router.navigate(['/', 'addon-card']);
        } else {
          this.router.navigate(['/', 'success']);
        }
      }
      else {
        if (this.sharedService.trackApplicationResponse.enableDataCaptureFlag) {
          this.router.navigate(['/', 'complete-application']);
        } else if (this.sharedService.trackApplicationResponse.enableDocumentListFlag) {
          let channel: any;
          let data = window['digitalData'];
          if (this.sharedService.trackApplicationResponse) {
            channel = this.sharedService.trackApplicationResponse.channelCode;
          } else {
            channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
          }
    
          if(channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
            data.page = { pageName: 'sbi-card:banca doc-upload:campaign', pageType: 'Banca' };
          } else if (IS_CAMPAIGN || sessionStorage.getItem('campaign')=='true') {
            data.page = { pageName: 'sbi-card:eapply doc-upload:campaign', pageType: 'Campaign' };
          } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
            data.page = { pageName: 'sbi-card:reapply doc-upload:reapply', pageType: 'reapply' };
          } else {
            data.page = { pageName: 'sbi-card:eapply doc-upload:eapplyform', pageType: 'Eapply' };
          }
          sessionStorage.setItem('digitalData', JSON.stringify(data));
          this.sharedService.appCompleted = true;
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
          sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.applicationNumber);
          let requestApp = {
            "applicationNumber": this.sharedService.trackApplicationResponse.applicationNumber
          }
          this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
            console.log("fetch params from app component 1009");
            const res = { ...response.body };
            console.log("response952" + res);
            if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
              if (res.FetchDocUploadParamsRsType.status) {
                let accessToken: any;
                let expiryTime: any;
                if (response.headers && response.headers.get("access_token")) {
                  accessToken = response.headers.get("access_token");
                }
                if (response.headers && response.headers.get("expiry_time")) {
                  expiryTime = response.headers.get("expiry_time");
                }
                if (accessToken) {
                  sessionStorage.setItem("s24_access_token", accessToken);
                }
                if (expiryTime) {
                  sessionStorage.setItem("s24_expiry_time", expiryTime);
                }
                sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
                sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
                const docUploadStatus = res.FetchDocUploadParamsRsType.docUploadStatusFlag;
            console.log("docuploadstatus1077"+ docUploadStatus);
            console.log("navigate1078"+ this.sharedService.navigateToDocUpload);
            if (docUploadStatus == 'Y' || docUploadStatus == 'N' || docUploadStatus == 'D') {
              console.log("in if block" + docUploadStatus);
              this.sharedService.navigateToDocUpload = false;
  
              if(this.sharedService.fromSwiftJourney){
                console.log("inswifyjourney 1084");
                console.log("navigate"+ this.sharedService.navigateToDocUpload);
                console.log("702" + this.sharedService.trackApplicationResponse);
                console.log("703" + this.sharedService.trackApplicationResponse.data.enableAppointmentFlag);
                console.log("704" + this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag);
                if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.data.enableAppointmentFlag || this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag)) {
                  console.log("inside if" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'schedule-appointment']);
                  // this.dialog.closeAll();
                } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.data.enableCrossSellFlag))) {
                  console.log("inside else if" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else {
                  console.log("inside else" + this.sharedService.trackApplicationResponse);
                  this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                }
              }
              else {
                console.log("In eapply journey 1104");
                if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag)) {
                  this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.enableCrossSellFlag))) {
                  this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                } else {
                  this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                  this.dialog.closeAll();
                }
              }
              
            } else if (docUploadStatus == 'I' || docUploadStatus == '') {
              console.log("else if part1118" + docUploadStatus);
              this.sharedService.navigateToDocUpload = true;
              this.createHiddenForm();
            }
            console.log("before createhidden method 1122");
            // this.createHiddenForm();
          } else {
            console.log("else part" + res.FetchDocUploadParamsRsType.docUploadStatusFlag);
            this.disableService = 0;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
            return this.createHiddenForm();
          }
        }
          }, err => {
            window["digitalData"].error = { message: GENERIC_ERROR };
            if(window['_satellite']){
              _satellite.track('form_error');
            }
            console.log("1033 line");
            this.createHiddenForm();
          })
    
        } else if (this.sharedService.trackApplicationResponse && (this.sharedService.trackApplicationResponse.enableAppointmentFlag || this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag)) {
          console.log("1037 else if block");
          this.router.navigate(['/', 'schedule-appointment']);
        } else if (this.sharedService.trackApplicationResponse && ((this.sharedService.trackApplicationResponse.enableAddOnListFlag) || (this.sharedService.trackApplicationResponse.enableCrossSellFlag))) {
          console.log("1040 else if block");
          this.router.navigate(['/', 'addon-card']);
        } else {
          console.log("1043 else if block");
          this.router.navigate(['/', 'success']);
        }
      }  
                                                                  ///===============> change required for swift journey
  
    }

    createHiddenForm() {
      console.log("createHiddenForm");
      var form = document.createElement("form");
      form.method = "POST";
      form.action = DOC_UPLOAD_LINK;
      document.body.appendChild(form);
      form.submit();
    }
  
    closeApp() {
      this.router.navigate(['/', 'success']);
    }
  
  
    fetchOffer() {
      let channel: any;
      if (this.sharedService.trackApplicationResponse) {
        if(this.sharedService.fromSwiftJourney){
          channel = this.sharedService.trackApplicationResponse.data.channelCode;
        }
        else {
          channel = this.sharedService.trackApplicationResponse.channelCode;
        }
      } else {
        channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
      }
  
      let requestBody = {
        cardType: this.cardSelected,
        cardChannelCode: channel,
        cityList: 'N',
        companyList: 'N',
        bancaCityList: 'N',
        designationList: 'N',
        feeAndOfferDetails: 'Y',
      }
      this.loaderService.show()
      this.qdeService.fetchMatserData(requestBody).subscribe((res: any) => {
        console.log("fetchMatserData", res);
        if (res) {
          console.log("Inside ifcondition", res);
          this.loaderService.hide()
          console.log("afterloaderservice hide", res);
          if (res && res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.feeAndOfferDetails) {
            console.log("second ifcondtion", res);
            if (IS_CAMPAIGN) {
              if (res.eapplyMasterDataRsType.feeAndOfferDetails.offerCampaignFlag && res.eapplyMasterDataRsType.feeAndOfferDetails.offerCampaignVerbiage) {
                this.showOfferFlag = res.eapplyMasterDataRsType.feeAndOfferDetails.offerCampaignFlag == 'Y' ? true : false;
                this.offerVerbiage = res.eapplyMasterDataRsType.feeAndOfferDetails.offerCampaignVerbiage;
                sessionStorage.setItem('offerFlag', this.showOfferFlag)
              }
            } else {
              if (res.eapplyMasterDataRsType.feeAndOfferDetails.offerEapplyFlag && res.eapplyMasterDataRsType.feeAndOfferDetails.offerEapplyVerbiage) {
  
                this.showOfferFlag = res.eapplyMasterDataRsType.feeAndOfferDetails.offerEapplyFlag == 'Y' ? true : false;
                this.offerVerbiage = res.eapplyMasterDataRsType.feeAndOfferDetails.offerEapplyVerbiage;
                sessionStorage.setItem('offerFlag', this.showOfferFlag)
              }
            }
            this.errorMessage = '';
            this.sharedService.feeCodeForDataCapture = res.eapplyMasterDataRsType.feeAndOfferDetails.feeCode;
          }
  
        }
      }, error => {
        this.errorMessage = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        this.loaderService.hide()
      })
    }

  
    // New changes are added for Existing Track App Journey
    firstStepValueStatus(){
      let i: any; 
      for(i=0; i<this.stepsInfo.length; i++){
        if(this.stepsInfo[i].stepState == 'In-progress' || this.stepsInfo[i].stepState == 'Delivered' || this.stepsInfo[i].stepState == 'RTO' || this.stepsInfo[i].stepState == 'POS' || this.stepsInfo[i].stepState == 'Intrasit'){
          this.currentstatus = this.stepsInfo[i].stepName;
          this.trackStatusImg = true;
        }
        if(this.stepsInfo[i].stepState == 'Declined'){
          this.cardDeclined = true;
        }
        if(this.stepsInfo[2].stepState == 'Completed'){
          this.cardApproved = true;
        }
        if(this.stepsInfo[i].stepState == 'Delivered'){
          this.cardDelivered = true;
          this.cardApproved = false;
          this.disableTrackingInstructionFailedDelivery = true;
          this.disableTrackingInstructionTabs = true;
        }
        if(this.stepsInfo[i].stepState == 'Intrasit'){
          this.cardIntrasit = true;
          this.cardApproved = false;
          // Disabled the Track Your card Delivery Tab Prdoduction Fix --Rajesh.
          if(this.currentAwbnumber == 'Not Available' ||  this.currentAwbnumber==""){ 
            this.disableTrackingDeliveryTabs = true;
          } else{
            this.disableTrackingDeliveryTabs = false;
          }
         
        }
        if(this.stepsInfo[i].stepState == 'RTO'){
          this.cardRto = true;
          this.cardApproved = false;
          this.disableTrackingInstructionFailedDelivery = true;
          this.disableTrackingInstructionTabs = true;
        }
        if(this.stepsInfo[i].stepState == 'POS'){
          this.cardApproved = false;
          this.disableTrackingInstructionFailedDelivery = true;
          this.disableTrackingInstructionTabs = true;
        }
      }
      console.log("stepsInfo inprogress", this.currentstatus);
    }


      
  showhideCardTrackingDelivery(action:String){
    if(action == "Application-status-journey"){
      this.showAlicationStatusJourney = true;
      this.showTrackYourCardDelivery = false;
      this.showUpdateDeliveryInstruction = false;
      this.trackYourDeliveryStatus = false;
      this.updateDeliveryStatus = false;
      this.firstStepValueStatus();
      this.subStatusFlag = false;
      this.validateSaveInstructionButtonDisabled = true;
      this.saveInstructionSuccessMsg = false;
      this.showServiceErrorMsg = false;
    }
    else if (action == "Track-your-card-delivery"){
      this.showAlicationStatusJourney = false;
      this.showTrackYourCardDelivery = true;
      this.showUpdateDeliveryInstruction = false;
      this.trackYourDeliveryStatus = true;
      this.updateDeliveryStatus = false;
      this.cardDelivered = false;
      this.cardDeclined = false;
      this.cardApproved = false;
      this.cardIntrasit = false;
      this.cardRto = false;
      this.validateSaveInstructionButtonDisabled = true;
      this.saveInstructionSuccessMsg = false;
      this.showServiceErrorMsg = false;
      this.trackCardDelivery();

    }
    else if (action == "Update-delivery-instruction"){
      this.showAlicationStatusJourney = false;
      this.showTrackYourCardDelivery = false;
      this.showUpdateDeliveryInstruction = true;
      this.trackYourDeliveryStatus = false;
      this.updateDeliveryStatus = true;
      this.cardDelivered = false;
      this.cardDeclined = false;
      this.cardApproved = false;
      this.cardIntrasit = false;
      this.cardRto =false;
      this.subStatusFlag = true;
      this.trackStatusImg = false;

    }
  }
  clickpostStatusCode:any;
 trackCardDelivery(){
    this.trackShippmentDelivery();
    this.firstStepValueStatus();
    this.showAlicationStatusJourney = false;
    this.showTrackYourCardDelivery = true;
    // Disabled the Track Your card Delivery Tab Prdoduction Fix --Rajesh.
    if(this.currentAwbnumber == 'Not Available' ||  this.currentAwbnumber==""){
      this.disableTrackingDeliveryTabs = true; 
    }else{
      this.disableTrackingDeliveryTabs = false;
    }
    
    this.disableTrackingInstructionTabs = false;
    this.trackYourDeliveryStatus = true;
    this.cardDelivered = false;
    this.cardIntrasit = false;
    this.cardRto = false;
    this.subStatusFlag = true;
    this.trackStatusImg = false;
  }
  seeMoreOptionsShow(){
    this.showAllFlag = true;
  }
  myFunc(num1) {
    console.log(num1);//here you will get input value through ng-model
  }
  onDateChange(e){
    this.updateDate= e.target.value;
    this.validateSaveInstructionButtonDisabled = false;
 }
 selectedDate(Date: Date){

 }
getTrackedInstructionsData(){
  this.sendTrackedInstructions();
}
isCurrentDate(index: number){// Disable the first element(index 0)
}

  //Call 'Track Your Card Delivery' Response 
  trackShippmentDelivery() {
    const request = {
      "Filler":[
        {
          "name":"ABC",
          "value" : "XYZ",
        }
      ]
    } 
      
      let obj = {
      CourierPartnerID: this.courierPartnerId,
      AWBNum: this.currentAwbnumber ,  
      "Fillers" : [request]
    };

    this.loaderService.show();
    this.trackshipmentService.trackShippmentDelivery(obj).subscribe((response: any) => {
      response = TRACK_GEN_SHIPMENT_RESPONSE_URL_DECRYPT ? this.encryptDecService.get(response) : response;
      response = JSON.parse(response);
      if(response){
        this.loaderService.hide();
        if(response.ShipmentTrackingResponse.shipmentStatus === "success"){
          this.trackCardDeliry = response.ShipmentTrackingResponse.shipmentDetails ? response.ShipmentTrackingResponse.shipmentDetails : [];
          this.updateInstrintions = response.ShipmentTrackingResponse.deliveryDatesOption ? response.ShipmentTrackingResponse.deliveryDatesOption : [];
          this.shipmentCourierName = response.ShipmentTrackingResponse.CourierName ? response.ShipmentTrackingResponse.CourierName : 'Not Available';
          this.shipmentAWBName = response.ShipmentTrackingResponse.AWBNumber ? response.ShipmentTrackingResponse.AWBNumber : 'Not Available';
          this.shipmentPreferDate = response.ShipmentTrackingResponse.PreferredDate ? response.ShipmentTrackingResponse.PreferredDate : 'Not Available';
          this.lastElementCardDeliveryVerbiages = true; 
          this.lastElement = this.trackCardDeliry.slice(-1)[0];
          this.selectedDateRes = response.ShipmentTrackingResponse.selectedDateRes ? response.ShipmentTrackingResponse.selectedDateRes: null;
          this.showPreferdateErrorMsg = response.ShipmentTrackingResponse.isCurrentDate ? response.ShipmentTrackingResponse.isCurrentDate: false;
          if(this.lastElement.ClickpostStatusCode === "9"){
            this.isBokedFalied = true;
            this.isImageFailed = true;
            this.disableTrackingInstructionFailedDelivery = false;
            this.disableTrackingInstructionTabs = false;
          }
          if(this.lastElement.ClickpostStatusCode === "4" || this.lastElement.ClickpostStatusCode === "5" || this.lastElement.ClickpostStatusCode === "1004" || this.lastElement.ClickpostStatusCode === "6" || this.lastElement.ClickpostStatusCode === "8" || this.lastElement.ClickpostStatusCode === "14"){
            this.disableTrackingInstructionFailedDelivery = true;
          } 
          if(this.showPreferdateErrorMsg == true){
            this.showPreferdateMsg = false;
          }    
          else if(this.shipmentPreferDate == 'Not Available'){
            this.disableTrackingInstructionTabs = true;
          }
          else{}
        }
        else if(response.ShipmentTrackingResponse.shipmentStatus === "failure"){
          this.shipmentCourierName = response.ShipmentTrackingResponse.CourierName ? response.ShipmentTrackingResponse.CourierName : 'Not Available';
          this.shipmentAWBName = response.ShipmentTrackingResponse.AWBNumber ? response.ShipmentTrackingResponse.AWBNumber : 'Not Available';
          this.shipmentPreferDate = response.ShipmentTrackingResponse.PreferredDate ? response.ShipmentTrackingResponse.PreferredDate : "";
          this.trackingBookedFailedFlag = true;
          this.disableTrackingInstructionTabs = true;
          this.currentCouriername = this.shipmentCourierName;
          this.currentAwbnumber = this.shipmentAWBName;
          this.disableTrackingInstructionFailedDelivery = true;
          if(this.shipmentPreferDate === ""){
            this.disableTrackingInstructionFailedDelivery = true;
          }

        }
        else{
          this.trackingBookedFailedFlag = true;
          this.disableTrackingInstructionTabs = true;
          this.subStatusFlag = false;
        }
      }
      else{
        console.log('trackShippmentDelivery else service', response);
      }   

    }, error => {
      this.errorMessage = GENERIC_ERROR;
      this.loaderService.hide()
      });
  }

  //Send 'Save Instructions' to Backend
  sendTrackedInstructions() {
    let currentTime  = new Date();
    this.trackCardCurrentDateAndTime = this.datePipe.transform(currentTime, "hh :mm:ss");
    let PreferedCurrentDate = this.updateDate + ' ' + this.trackCardCurrentDateAndTime;
    let requestBody = {
        "Filler":[
          {
            "name":"Landmark",
            "value" : this.updateLandmarkValue
          },
          {
            "name":"Preferred_Date",
            "value" : PreferedCurrentDate,
          }
        ]
      };
      let obj = {
        CourierPartnerID: this.courierPartnerId,
        AWBNum: this.currentAwbnumber,        
        CourierName: this.currentCouriername,
        "Fillers" : [requestBody]
      };
      this.loaderService.show()
      this.trackshipmentService.sendTrackedInstructions(obj).subscribe((result: any) => {
      result = TRACK_GEN_UPDATE_INSTRUCTION_URL_DECRYPT ? this.encryptDecService.get(result) : result;
        if(result){
          this.loaderService.hide()
          if(result.statusCode === "000" ){
            this.saveInstructionSuccessMsg = true;
            this.showServiceErrorMsg = false;
            this.showPreferdateMsg = false;
          }
          else if(result.statusCode === "999"){
            this.showServiceErrorMsg = true;
            this.showPreferdateMsg = false;
          }else{
            this.showServiceErrorMsg = true;
          }
        }
      }, error => {
        this.errorMessage = GENERIC_ERROR;
        this.loaderService.hide()
       });
  }
  


}
